import { formatDistanceToNow } from 'date-fns';

const timeAgo = value => {
  return value ? formatDistanceToNow(new Date(value), { addSuffix: true }) : '';
};

export default timeAgo;
